export default {"src":"/_next/static/media/live-stream.cd1e0cae.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};